<template>
  <div id="add-report" class="vx-card p-3">
    <div class="vx-row">
      <div class="vx-col md:w-1/5 w-full">
        <vs-list style="max-height: 600px; overflow-y: auto;">
          <vs-list-header :title="className" color="danger"></vs-list-header>
          <vs-list-item 
            class="student-item cursor-pointer"
            :class="{'active':stu.active}"
            :title="stu.name" 
            :subtitle="stu.report == ''?'未生成':'已生成'" 
            v-for="stu in studentList" 
            :key="stu.id"
            @click.native="selectedStuReport(stu)">
            <template slot="avatar">
              <vs-avatar v-if="stu.user.avatar" :src="stu.user.avatar" />
              <vs-avatar v-else :src="require('@/assets/images/profile/default-avatar.png')" />
            </template>
          </vs-list-item>
        </vs-list>
      </div>
      <div class="vx-col md:w-4/5 w-full">
        <div class="vx-row mb-2">
          <div class="vx-col flex items-center">
            <span class="text-lg">课程：</span>
            <v-select v-model="selectedCourse" :options="courseList" />
          </div>
          <div class="vx-col flex items-center">
            <span class="text-lg">学年：</span>
            <v-select v-model="selectedYear" :options="yearList" />
          </div>
          <div class="vx-col flex items-center">
            <span class="text-lg">学期：</span>
            <v-select v-model="selectedTerm" :options="termList" />
          </div>
          <div class="vx-col flex items-center">
            <vs-button class="h-full" size="small" icon-pack="feather" icon="icon-search" @click="getStudentList">查看</vs-button>
          </div>
        </div>
        <vs-divider/>
        <div v-if="currentStu">
          <div class="vx-row">
            <div class="vx-col flex items-center">
              <span class="text-lg">学生姓名：</span>
            </div>
            <div class="vx-col flex items-center">
              <vs-avatar v-if="currentStu.user.avatar" :src="currentStu.user.avatar" />
              <vs-avatar v-else :src="require('@/assets/images/profile/default-avatar.png')" />
              <span class="ml-2">{{ currentStu.name }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col flex items-center">
              <span class="text-lg">期末成绩：</span>
            </div>
            <div class="vx-col">
              <vs-input-number v-model="currentReport.final_score" icon-inc="expand_less" icon-dec="expand_more" max="100" min="0" />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col">
              <span class="text-lg">学期评语：</span>
            </div>
            <div class="vx-col md:w-2/3 w-full">
              <vs-textarea :counter="commentNumLimit" height="160" placeholder="快给Ta本学期的课程表现写评语吧！" :counter-danger.sync="counterDanger" v-model="currentReport.comment" />
              <div class="comment-template">
                <vs-button v-for="(item, index) in commentTemplate" :key="item.id"
                  type="border"
                  class="mr-2"
                  size="small"
                  color="warning"
                  @click="useCommentTemplate(item)"
                >
                  模版{{ index+1 }}
                </vs-button>
              </div>
            </div>
          </div>
          <div class="vx-row" v-if="shareQrcode != ''">
            <div class="vx-col">
              <span class="text-lg">分享二维码：</span>
            </div>
            <div class="vx-col md:w-2/3 w-full">
              <qrcode :value="shareQrcode" :options="{ width: 200 }"></qrcode>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col">
              <span class="text-lg text-white">提交按钮：</span>
            </div>
            <div class="vx-col flex">
              <vs-button @click="postStuReport" icon-pack="feather" icon="icon-check-circle">提交</vs-button>
              <vs-button class="ml-2" color="warning" icon-pack="feather" icon="icon-refresh-ccw" @click="resetStuReport">重置</vs-button>
            </div>
          </div>
        </div>
        <div v-else>
          <p>请在左侧选择要生成学期汇报的学生。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import VueQrcode from '@chenfengyuan/vue-qrcode'

import config from '@/config'
import { courseListByPass } from '@/api/course'
import { getStudentReportList, postStudentReport } from '@/api/school'

export default {
  data() {
    return {
      classId: 0,
      className: '',
      studentList: [],
      courseList: [],
      selectedCourse: '',
      yearList: [
        '2021',
        '2022'
      ],
      selectedYear: '2021',
      termList: [
        '上学期',
        '下学期'
      ],
      selectedTerm: '上学期',
      currentStu: false,
      currentReport: {
        id: 0,
        final_score: 0,
        comment: '',
      },
      commentNumLimit: 300,
      counterDanger: false,
      shareQrcode: '',
      commentTemplate: [
        {
          id: 1,
          comment: '你刻苦好学，勤奋踏实。上课时，你思维活跃，积极举手回答问题。每次作业都完成的很出色。你在这几次大赛中表现优异，会在作品中表达自己的想法，希望你能发扬学习创新精神，继续保持优秀成绩。'
        },
        {
          id: 2,
          comment: '你是个讲文明懂礼貌深受老师喜爱的好孩子。老师最喜欢听到你响亮而又有感情的回答。作业每次都能按时认真完成。通过一学期的学习，学习上有了明显进步，这是值得高兴的事，希望你能继续努力，争取更大的进步。'
        },
        {
          id: 3,
          comment: '你是个乖巧、懂事、善解人意的孩子。课堂上能积极思考老师提出的问题。能认真完成老师布置的作业。学习成绩良好，但不够拔尖，望你继续努力，老师关注着你的进步。'
        },
        {
          id: 4,
          comment: '懂得尊敬老师，和同学友好相处。但老师发现你上课时有时分散精神，开小差。学习上不要怕辛苦，利用暑假把没学会的补上，老师相信你一定能行的。加油啊！'
        }
      ]
    }
  },
  components: {
    vSelect,
    'qrcode': VueQrcode,
  },
  mounted() {
    this.classId = this.$route.query.classId
    this.className = this.$route.query.className
    this.getCourseListByPass()
  },
  methods: {
    getCourseListByPass() {
      courseListByPass().then(res => {
        if (res.code == 1) {
          this.courseList = res.data.list
          this.selectedCourse = this.courseList[0]
          this.getStudentList()
        }
      })
    },
    getStudentList() {
      getStudentReportList({
        class_id: this.classId,
        course_id: this.selectedCourse.id,
        year: this.selectedYear,
        term: this.selectedTerm,
        mode: 1,
      }).then(res => {
        if (res.code == 1) {
          this.studentList = res.data.list
          this.currentStu = false
        }
      })
    },
    selectedStuReport(row) {
      this.studentList.map(e => { return e.active = false })
      row.active = true
      this.currentStu = row
      if (row.report != '') {
        this.currentReport = row.report
        this.shareQrcode = `${config.shequUrl}/school/report?id=${this.currentReport.id}`
      } else {
        this.shareQrcode = ''
        this.resetStuReport()
      }
    },
    resetStuReport() {
      this.currentReport = {final_score: 0, comment: ''}
    },
    postStuReport() {
      if (this.currentReport.comment.length > this.commentNumLimit) {
        this.$vs.notify({
          color: "warning",
          text: "评语太长啦～ 要在300字以内喔！",
          title: "提示",
          iconPack: "feather",
          icon: "icon-alert-circle",
        });
        return
      }
      postStudentReport({
        class_id: this.classId,
        course_id: this.selectedCourse.id,
        student_id: this.currentStu.user_id,
        year: this.selectedYear,
        term: this.selectedTerm,
        comment: this.currentReport.comment,
        final_score: this.currentReport.final_score
      }).then(res => {
        if (res.code == 1) {
          this.$vs.notify({
            color: "success",
            text: res.msg,
            title: "提示",
            iconPack: "feather",
            icon: "icon-alert-circle",
          });
          this.currentReport.id = res.data.report_id
          this.shareQrcode = `${config.shequUrl}/school/report?id=${this.currentReport.id}`
          this.currentStu.report = this.currentReport
        }
      })
    },
    useCommentTemplate(row) {
      this.currentReport.comment = row.comment
    }
  }
}
</script>
<style lang="scss">
  .student-item.active {
    background-color: rgba(var(--vs-primary), 1) !important;
    border-radius: .25rem !important;
    --text-opacity: 1 !important;
    color: #ffffff !important;
    color: rgba(255, 255, 255, var(--text-opacity)) !important;
  }
</style>